import i18n from 'i18next';
import {initReactI18next} from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { en } from 'react-native-paper-dates';

i18n.use(LanguageDetector).use(initReactI18next).init({
    debug: true,
    fallbackLng: 'en',
    interpolation: {
        escapeValue: false
    },
    resources: {
        //Translation here
        en: {
            translation: {
                //Home page
                noTrainingForDay: "You have no training for this date",
                myTrainings: "My trainings",
                allTrainings: "All trainings",
                showHomeSearchDropDown: "Show",
                changePassword: "Change password",
                //App page = titles
                home: "Home",
                viewClients: "Clients",
                viewTrainings: "Trainings",
                createTrainingContainer: "New Training",
                editTrainingContainer: "Update training",
                addExercises: "Add Exercises",
                editClientContainer: "Update Client",
                createClientContainer: "New Client",
                createExercise: "New Exercise",
                createExerciseGroup: "New Exercise Group",
                editExercise: "Edit Exercise",
                appSettings: "Settings",
                addUpdateRound: "Exercise Group",
                clientView: "Client",
                exerciseGroupsContainer: "Exercise groups",
                userSettings: "User Settings",
                editExerciseGroup: "Update Exercise Group",
                login: "Log",
                previousTrainings: "Previous trainings of client",
                createFitnessCenterContainer: "New fitness center",
                updateFitnessCenterContainer: "Update fitness center",
                viewExercises: "Exercises",
                //SettingsScreen
                fitnessCenter: "Fitness Center",
                administration: "Administration",
                logOut: "Log Out",
                personalSettings: "Personal settings",
                save: "Save",
                exerciseGroup: "Exercise groups",
                selectionOfFitnessCenter: "Selection of fitness center",
                createFitnessCenter: "Create fitness center",
                updateFitnessCenter: "Update fitness center",
                addUserToFitnessCenter: "Add user to fitness center",
                deleteUserFromFitnessCenter: "Delete user from fitness center",
                //UserSettings
                oldPassword: "Old Password",
                userSettingsChangePassword: "Change password",
                //RepeatPasswordComponent
                password: "Password",
                repeatedPassword: "Repeated password",
                passwordsNotTheSame: "Passwords don't match",
                //BottomMenu
                bottomMenuHome: "Home",
                bottomMenuClient: "Client",
                bottomMenuTrainings: "Trainings",
                bottomMenuExercise: "Exercise",
                //TrainingContainer
                loadMoreTrainingsButton: "Load more",
                //ClientsContainer
                clientsContainerSearch: "Search",
                //ExercisesContainer
                exercisesContainerSearch: "Search",
                //CreateEditExerciseInfo
                exerciseName: "Name",
                exerciseExerciseGroupLabel: "Exercise group",
                exerciseNumberOfSelected: "Number of selected",
                exerciseSearch: "Search",
                exerciseDescription: "Description",
                exerciseSaveButton: "Save",
                exerciseCancelButton: "Cancel",
                //CreateEditClientInfo
                clientName: "Name",
                clientFamilyName: "Family Name",
                clientEmail: "Email",
                clientPhoneNumber: "Phone number",
                clientAdditionalInfo: "Additional info",
                clientSave: "Save",
                clientCancel: "Cancel",
                //CreateTrainingInfo
                generalInfo: "General information",
                client: "Client",
                trainingNumber: "Training number",
                date: "Date",
                time: "Time",
                status: "Status",
                executor: "Executor",
                trainingStatus: "Training status",
                cancelLabel: "Cancel",
                confirmLabel: "Save",
                inPreparation: "In preparation",
                ready: "Ready",
                done: "Done",
                canceled: "Canceled",
                //LoginScreen
                usernameOrEmail: "Username or email",
                passwordLoginScreen: "Password",
                loginButton: "Login",
                noAccount: "No account?",
                register: "Please register",
                //FitnessCenterSelectionDialog
                selectFitnessCenter: "Select fitness center",
                independentUserLabel: "Independent user",
                //AddUserToCenterDialog
                usersUsername: "Users username",
                userRole: "User role",
                saveButton: "Save",
                cancelButton: "Cancel",
                addUserTo: "Add user to",
                //CreateEditFitnessCenterInfo
                fitnessCenterName: "Name",
                fitnessCenterAddress: "Address",
                fitnessCenterPhoneNumber: "Phone number",
                fitnessCenterEmail: "Email",
                fitnessCenterSave: "Save",
                fitnessCenterUpdate: "Update",
                fitnessCenterCancel: "Cancel",
                //SignUpScreen
                signUpUserName: "User name",
                signUpEmail: "Email",
                signUpName: "Name",
                signUpFamilyName: "Family name",
                signUpPassword: "Password",
                signUpRepeatedPassword: "Repeated password",
                registration: "Registration",
                youHaveAccount: "Do you have an account?",
                loginSUS: "Login",
                //SignUpScreen messages
                errorMessageUsername: "Missing username",
                errorMessageBadEmail: "Invalid email address",
                errorMessageFillOutName: "Missing name",
                errorMessageFillOutFamilyName: "Missing name",
                errorMessagePasswordsNotMatch: "Passwords do not match",
                createAccount:  "Create Account",
                alreadyHaveAccount: "Do you already have account?",
                logIn: "Login",
                //CreateTrainingContainer
                addGroupButton: "Add groups",
                saveButtonCreateTrainingContainer: "Save",
                previousTrainingsCtC: "Previous trainings",
                confirmation: "Confirmation",
                confirmationMessage: "Are you sure you want to delete the group?",
                //EditTrainingContainer
                addGroup: "Add group",
                copyTraining: "Copy training",
                deleteTraining: "Delete Training",
                previousTrainingsEtC: "Previous trainings",
                confirmationMessageEdit: "Are you sure you want to delete a training?",
                //ExerciseInRoundCard
                showInstructions: "Show instructions",
                hideInstructions: "Hide instructions",
                //RoundCard
                showInstructionsR: "Show instructions",
                hideInstructionsR: "Hide instructions",
                groupExerciseInRoundCard: "group",
                noExerciseAddedRightNow: "No exercises added",
                deleteGroupOrAddExercise: "Delete group or add exercises",
                //AddUpdateRound
                groupSectionHeader: "Group", //section header
                backButton: "Back", //button
                NoExerciseAdded: "No exercises added.",
                deleteGroupOrAddExerciseAUR: "Delete group or add exercise",
                areYouSureYouWantToDeleteGroup: 'Are you sure that you want to delete group"?',
                addExercise: "Add exercises",
                deleteGroup: "Delete group",
                //PreviousTraining
                previousTrainingFillInExercise: "Fill in exercises",
                previousTrainingGroup: "Group",
                previousTrainingClient: "Client",
                //CreateEditExerciseGroupInfo
                nameCEEGI: "Name",
                descriptionCEEGI: "Description",
                saveButtonCEEGI: "Save",
                cancelButtonCEEGI: "Cancel",
                //ExerciseGroupsContainer
                confirm: "Confirm",
                confirmDeletionOfGroup: "Are you sure that you want to delete exercise group ",
                //ExerciseInfoDialog
                saveEID: "Save",
                nextEID: "Next",
                exerciseDoneInPreviousTrainingEID: "*Exercise was done in previous training.",
                exerciseDone2TrainingsAgoEID: "*Exercise was done 2 trainings ago",
                exerciseDone3TrainingsAgoEID: "*Exercise was done 3 trainings ago",
                numberOfRepetition: "Number of repetitions",
                weightLengthEID: "Wight/Length",
                addDescriptionEID: "Add description",
                //ClientView
                additionalInfo: "Additional info",
                trainings: "Trainings",
                loadMore: "Load",
                confirmationCV: "Confirmation",
                areYouSureCV: "Are you sure you want to delete the client?",
                //ExercisesContainer
                areYouSureYouWantToDeleteExercise: "Are you sure you wan't to delete the exercise ",
                //ConfirmationDialog
                cancelCD: "Cancel",
                confirmCD: "Confirm",
                //UserList
                deletionOfUserFromFC: "Removal of user from Fitness center.",
                //CalendarDialog
                previousCD: "Previous",
                nextCD: "Next",
                //TrainingTimeCard
                completeTTC: "Complete",
                trainingNumberTTC: "Training number",
                //Generic
                searchBox: "Search",
            }
        },
        srb: {
            translation: {
                //Home page
                noTrainingForDay: "Nemate zakazanih treninga za odabrani datum",
                myTrainings: "Moji treninzi",
                allTrainings: "Svi treninzi",
                showHomeSearchDropDown: "Prikaži",
                changePassword: "Promeni lozinku",
                //App page = titles
                home: "Dom",
                viewClients: "Klijenti",
                viewTrainings: "Treninzi",
                createTrainingContainer: "Novi trening",
                editTrainingContainer: "Izmena treninga",
                addExercises: "Dodaj vežbe",
                editClientContainer: "Izmena klijenta",
                createClientContainer: "Novi klijent",
                createExercise: "Nova vežba",
                createExerciseGroup: "Nova grupa vežbi",
                editExercise: "Izmena vežbe",
                appSettings: "Podešavanja",
                addUpdateRound: "Grupa vežbi",
                ClientView: "Klijent",
                exerciseGroupsContainer: "Grupe vežbi",
                userSettings: "Podešavanje koristnika",
                editExerciseGroup: "Izmena grupe vežbi",
                login: "Ulogovanje",
                previousTrainings: "Prethodni treninzi klijenta",
                createFitnessCenterContainer: "Novi fitnes centar",
                updateFitnessCenterContainer: "Izmeni fitnes centar",
                viewExercises: "Vežbe",
                //SettingsScreen
                fitnessCenter: "Fitnes centar",
                administration: "Administracija",
                logOut: "Izlogujte se",
                personalSettings: "Lična podešavanja",
                save: "Snimi",
                exerciseGroup: "Grupe vežbi",
                selectionOfFitnessCenter: "Izbor fitnes centra",
                createFitnessCenter: "Kreiraj fitnes centar",
                updateFitnessCenter: "Izmeni fitnes centar",
                addUserToFitnessCenter: "Dodaj korisnika u fitnes centar",
                deleteUserFromFitnessCenter: "Obriši korisnika iz fitnes centra",
                //UserSettings
                oldPassword: "Stara lozinka",
                userSettingsChangePassword: "Izmeni lozinku",
                //RepeatPasswordComponent
                password: "Lozinka",
                repeatedPassword: "Ponovljena lozinka",
                passwordsNotTheSame: "Lozinke nisu iste",
                //BottomMenu
                bottomMenuHome: "Dom",
                bottomMenuClient: "Klijent",
                bottomMenuTrainings: "Traninzi",
                bottomMenuExercise: "Vežbe",
                //TrainingContainer
                loadMoreTrainingsButton: "Učitaj još",
                //ClientsContainer
                clientsContainerSearch: "Pretraga",
                //ExercisesContainer
                exercisesContainerSearch: "Pretraga",
                //CreateEditExerciseInfo
                exerciseName: "Naziv",
                exerciseExerciseGroupLabel: "Grupe vežbi",
                exerciseNumberOfSelected: "Broj odabranih",
                exerciseSearch: "Pretraga",
                exerciseDescription: "Opis",
                exerciseSaveButton: "Snimi",
                exerciseCancelButton: "Otkaži",
                //CreateEditClientInfo
                clientName: "Ime",
                clientFamilyName: "Prezime",
                clientEmail: "Email",
                clientPhoneNumber: "Broj telefona",
                clientAdditionalInfo: "Dodatne informacije",
                clientSave: "Snimi",
                clientCancel: "Otkaži",
                //CreateTrainingInfo
                generalInfo: "Opšte informacije",
                client: "Klijent",
                trainingNumber: "Broj treninga",
                date: "Datum",
                time: "Vreme",
                status: "Status",
                executor: "Izvrsilac",
                trainingStatus: "Status treninga",
                cancelLabel: "Otkaži",
                confirmLabel: "Potvrdi",
                inPreparation: "U pripremi",
                ready: "Spreman",
                done: "Završen",
                canceled: "Otkazan",
                //LoginScreen
                usernameOrEmail: 'Korisničko ime ili email',
                passwordLoginScreen: "Lozinka",
                loginButton: "Prijava",
                noAccount: "Nemate nalog?",
                register: "Registurjte se",
                //FitnessCenterSelectionDialog
                selectFitnessCenter: "Selekcija fitnes centra",
                independentUserLabel: "Samostalno",
                //AddUserToCenterDialog
                usersUsername: "Korisničko ime korisnika",
                userRole: "Uloga korisnika",
                saveButton: "Snimi",
                cancelButton: "Otkaži",
                addUserTo: "Dodavanje korisnika u",
                //CreateEditFitnessCenterInfo
                fitnessCenterName: "Naziv",
                fitnessCenterAddress: "Adresa",
                fitnessCenterPhoneNumber: "Broj telefona",
                fitnessCenterEmail: "Email",
                fitnessCenterSave: "Snimi",
                fitnessCenterUpdate: "Izmeni",
                fitnessCenterCancel: "Otkaži",
                //SignUpScreen
                signUpUserName: "Korisničko ime",
                signUpEmail: "Email",
                signUpName: "Ime",
                signUpFamilyName: "Prezime",
                signUpPassword: "Lozinka",
                signUpRepeatedPassword: "Ponovljena lozinka",
                registration: "Registracija",
                youHaveAccount: "Već imate nalog?",
                loginSUS: "Ulogujte se",
                //SignUpScreen messages
                errorMessageUsername: "Popunite korisničko ime",
                errorMessageBadEmail: "Nevalidna email adresa",
                errorMessageFillOutName: "Popunite ime",
                errorMessageFillOutFamilyName: "Popunite prezime",
                errorMessagePasswordsNotMatch: "Lozinke nisu iste",
                createAccount:  "Kreiraj nalog",
                alreadyHaveAccount: "Već imate nalog?",
                logIn: "Ulogujte se",
                //CreateTrainingContainer
                addGroupButton: "Dodaj grupu",
                saveButtonCreateTrainingContainer: "Snimi",
                previousTrainingsCtC: "Prethodni treninzi",
                confirmation: "Potvrda", //Using this for EditTrainingContainer as well and AddUpdateRound and other places
                confirmationMessage: 'Da li ste sigurni da želite da izbrišete grupu"?', //Using this in Edit as well
                //EditTrainingContainer
                addGroup: "Dodaj Grupu",
                copyTraining: "Kopiraj Trening",
                deleteTraining: "Obrisi Trening",
                previousTrainingsEtC: "Prethodni treninzi",
                confirmationMessageEdit: 'Da li ste sigurni da želite da izbrišete trening"?',
                //ExerciseInRoundCard
                showInstructions: "Prikaži instrukcije",
                hideInstructions: "Skloni instrukcije",
                //RoundCard
                showInstructionsR: "Show instructions",
                hideInstructionsR: "Hide instructions",
                groupExerciseInRoundCard: "grupa",
                noExerciseAddedRightNow: "Trenutno nema dodatih vežbi",
                deleteGroupOrAddExercise: "Izbrišite grupu ili dodajte vežbe",
                //AddUpdateRound
                groupSectionHeader: "Grupa", //section header
                backButton: "Nazad", //button
                NoExerciseAdded: "Trenutno nema dodatih vežbi",
                deleteGroupOrAddExerciseAUR: "Izbrišite grupu ili dodajte vežbe",
                areYouSureYouWantToDeleteGroup: 'Da li ste sigurni da želite da obrišete grupu"?',
                addExercise: "Dodaj vezbe",
                deleteGroup: "Izbrisi grupu",
                //PreviousTraining
                previousTrainingFillInExercise: "Vežbe nisu popunjene",
                previousTrainingGroup: "Grupa",
                previousTrainingClient: "Klijent",
                //CreateEditExerciseGroupInfo
                nameCEEGI: "Naziv",
                descriptionCEEGI: "Opis",
                saveButtonCEEGI: "Snimi",
                cancelButtonCEEGI: "Otkaži",
                //ExerciseGroupsContainer
                confirm: "Potvrda",
                confirmDeletionOfGroup: "Da li ste sigurni da želite da izbrišete grupu vežbi ?",
                //ExerciseInfoDialog
                saveEID: "Snimi",
                nextEID: "Dalje",
                exerciseDoneInPreviousTrainingEID: "*Vežba je rađena tokom prethodnog treninga",
                exerciseDone2TrainingsAgoEID: "*Vežba je rađena pre 2 treninga",
                exerciseDone3TrainingsAgoEID: "*Vežba je rađena pre 3 treninga",
                numberOfRepetition: "Broj ponavljanja",
                weightLengthEID: "Težine/trajanje",
                addDescriptionEID: "Dodatni opis",
                //ClientView
                additionalInfo: "Dodatne informacije",
                trainings: "Treninzi",
                loadMore: "Učitaj još",
                confirmationCV: "Potvrda",
                areYouSureCV: "Da li ste sigurni da želite da obrišete klijenta ?",
                //ExercisesContainer
                areYouSureYouWantToDeleteExercise: "Da li ste sigurni da želite da izbrišete vežbu",
                //ConfirmationDialog
                cancelCD: "Otkaži",
                confirmCD: "Potvrdi",
                //UserList
                deletionOfUserFromFC: "Brisanje korisnika iz Fitnes centra ",
                //CalendarDialog
                previousCD: "Prethodni",
                nextCD: "Sledeći",
                //TrainingTimeCard
                completeTTC: "Završen",
                trainingNumberTTC: "Trening broj",
                //Generic
                searchBox: "Pretraga",
            }
        }
    }
});
export default i18n;